/**
 * Helpers para construir URLs de media servidas por el local-api.
 *
 * El backend persiste `image_path` como prefix de carpeta (ej. "products/{uuid}").
 * Bajo esa carpeta hay siempre dos variantes: full.webp y thumb.webp.
 *
 * Estas URLs apuntan al local-api directo (no al origen del frontend), porque
 * la PWA y el local-api viven en orígenes distintos en dev (5173 vs 8001).
 */

import { API_BASE_URL } from "./api.ts";

const TRIMMED_BASE = API_BASE_URL.replace(/\/$/, "");

function mediaUrl(relPath: string): string {
  // relPath viene como "products/{uuid}", sin leading slash.
  return `${TRIMMED_BASE}/media/${relPath}`;
}

export function productThumbUrl(imagePath: string | null | undefined): string | null {
  if (!imagePath) return null;
  return `${mediaUrl(imagePath)}/thumb.webp`;
}

export function productImageUrl(imagePath: string | null | undefined): string | null {
  if (!imagePath) return null;
  return `${mediaUrl(imagePath)}/full.webp`;
}
